import PortfolioLinkStatus from './PortfolioLinkStatus';

export default PortfolioLinkStatus;
